export const EditPatientModal = ({
  patientToEdit,
  editPatientData,
  setEditPatientData,
  editPatientError,
  onConfirm,
  onCancel,
}) => {
  if (!patientToEdit) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1100
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '16px', padding: '2rem',
        maxWidth: '500px', width: '90%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '50%',
            backgroundColor: '#ebf8ff', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#4299e1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="#4299e1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 style={{ margin: 0, color: '#2d3748', fontSize: '1.5rem', fontWeight: '700' }}>Edit Patient</h2>
        </div>

        <p style={{ color: '#4a5568', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '1.5rem' }}>
          Update contact information for <strong>{patientToEdit.full_name}</strong>
        </p>

        {editPatientError && (
          <div style={{
            backgroundColor: '#fff5f5', border: '1px solid #fc8181',
            borderRadius: '8px', padding: '0.75rem', marginBottom: '1rem',
            color: '#c53030', fontSize: '0.875rem'
          }}>
            {editPatientError}
          </div>
        )}

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block', marginBottom: '0.5rem',
            fontWeight: '600', color: '#2d3748', fontSize: '0.95rem'
          }}>
            Phone Number
          </label>
          <input
            type="tel"
            value={editPatientData.phone}
            onChange={(e) => setEditPatientData({ ...editPatientData, phone: e.target.value })}
            placeholder="+1234567890"
            style={{
              width: '100%', padding: '0.75rem',
              border: '2px solid #e2e8f0', borderRadius: '8px',
              fontSize: '1rem', outline: 'none',
              transition: 'border-color 0.2s', boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#4299e1'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
        </div>

        <div style={{
          backgroundColor: '#f7fafc', borderRadius: '8px',
          padding: '0.75rem', marginBottom: '1.5rem',
          fontSize: '0.875rem', color: '#718096'
        }}>
          <strong>Note:</strong> Only phone number can be updated. Other patient information is locked for data integrity.
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.75rem 1.5rem', backgroundColor: '#e2e8f0', color: '#2d3748',
              border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600',
              cursor: 'pointer', transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#cbd5e0'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#e2e8f0'}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!editPatientData.phone}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: editPatientData.phone ? '#4299e1' : '#cbd5e0',
              color: 'white', border: 'none', borderRadius: '8px',
              fontSize: '1rem', fontWeight: '600',
              cursor: editPatientData.phone ? 'pointer' : 'not-allowed',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => { if (editPatientData.phone) e.target.style.backgroundColor = '#3182ce'; }}
            onMouseLeave={(e) => { if (editPatientData.phone) e.target.style.backgroundColor = '#4299e1'; }}
          >
            Update Patient
          </button>
        </div>
      </div>
    </div>
  );
};
